<div class="p-4 m-3">
    <div class="d-flex d-row align-items-center">
        <div class="text-dimmed flex-grow-1" translate>
            ProviderPayRates.PayRatesHistoryLabel
        </div>
        <div class="switch-container d-flex align-items-center">
            <ui-switch [(ngModel)]="includeObsolete" (click)="onIncludeObsoleteClick()" class="switch" color="#346ABC"
                size="small" switchColor="#E5E5E5"></ui-switch>
            <span class="text-dimmed check-text"> {{ 'ProviderPayRates.ShowObsoleteLabel' | translate }}
            </span>
        </div>
    </div>
    <div class="container pay-rates-history" *ngIf="payRates && payRates.length > 0">
        <div class="row column-headers mb-2">
            <div class="col-3" translate>ProviderPayRates.ValidFromColumnLabel</div>
            <div class="col-2" translate>ProviderPayRates.ValidToColumnLabel</div>
            <div class="col-2" translate>ProviderPayRates.PayRatesColumnLabel</div>
            <div class="col-2" translate>ProviderPayRates.CategoryColumnLabel</div>
        </div>
        <div class="mb-3 text-bayclub-blue" *ngFor="let payRateSet of payRates"
            [ngClass]="{'payrate-obsolete': payRateSet.isObsolete}">
            <div class="row">
                <div class="col-3"><span
                        *ngIf="!payRateSet.validTo">{{'ProviderPayRates.ValidSince' | translate }}</span>
                    {{payRateSet.validFrom.value | date:'MMMM d y'}}</div>
                <div class="col-2" *ngIf="payRateSet.validTo; else untilNow">
                    {{payRateSet.validTo.value | date:'MMMM d y'}}</div>
                <ng-template #untilNow>
                    <div class="col-2">-</div>
                </ng-template>

            </div>
            <div class="row" *ngFor="let payRate of payRateSet.payRates">
                <div class="col-2 offset-5">{{ payRate.hourlyRate | amount }}</div>
                <div class="col-5"> {{payRate.groupClassCategory.categoryName}} <span>|</span>
                    {{payRate.groupClassCategory.jobCostCode}}<span>|</span> {{payRate.groupClassCategory.clubCode}}
                </div>
            </div>
        </div>
    </div>
</div>